import * as Yup from 'yup';
import GoogleSheets from './index';

export const GOOGLE_SHEETS_CONFIG = {
  formComponent: GoogleSheets,

  initialValues: {
    folder: null,
    folderId: '',
    spreadsheetId: '',
    spreadsheetName: '',
    spreadsheet: null
  },

  validationSchema: Yup.object({
    name: Yup.string().trim().required(),
    folder: Yup.string().trim().nullable(),
    spreadsheet: Yup.string().trim().required()
  }),

  fieldNameMapping: {
    name: 'target-name',
    folderId: 'folder_id',
    spreadsheet: 'spreadsheet'
  }
};
